var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMessageIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.2243 9.22642C19.5479 6.28371 17.3432 3.99738 14.5335 3.32481L14.3105 3.27141C12.7987 2.90953 11.2288 2.90953 9.71697 3.27141L9.33586 3.36264C6.62297 4.01204 4.4943 6.21958 3.84121 9.06088L3.75236 9.44741C3.41588 10.9113 3.41588 12.4382 3.75236 13.9021C4.42994 16.8499 6.94114 18.9268 9.8279 18.9268H10.8893C11.2378 18.9268 11.5533 19.1515 11.6858 19.4902C12.1671 20.7208 13.511 21.3248 14.6841 20.8233L14.8022 20.7728C17.5131 19.6138 19.5339 17.1265 20.2209 14.1378C20.5908 12.5287 20.5941 10.8355 20.2243 9.22642Z",
    stroke: "#676767",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3047 9.05859H9.27302M15.3047 12.5148H11.4664",
    stroke: "#676767",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageIcon);
export default __webpack_public_path__ + "static/media/message-icon.b1d4d2cb547e556be199612e5eb20279.svg";
export { ForwardRef as ReactComponent };